import { useCallback } from "react"

import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { roadworksQueryKeys } from "../../queries/queryKeys"
import { useRoadworksProject } from "../../queries/useRoadworksProjectQuery"

import { useRoadworksMutation } from "./useRoadworksMutation"
import { useOnSuccessRoadwork } from "./utils"

export function useRoadworkDelete(
    roadwork,
    queryParameters,
    config = {},
) {
    const url = `roadworks/${roadwork?.uuid}/`
    const { data: roadworkProject } = useRoadworksProject()
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    const { enabled = true } = config
    const { onSuccess } = useOnSuccessRoadwork(roadwork)

    const onDeleteSuccess = useCallback((data) => {
        config?.onSuccess?.(data)
        onSuccess(data)

        queryClient.invalidateQueries({ queryKey: roadworksQueryKeys.projectTaskType() })
        invalidateDocumentProject(queryClient, selectedNetwork)
        invalidateDocumentsList(queryClient, selectedNetwork)
        queryClient.invalidateQueries({ queryKey: roadworksQueryKeys["project"]() })
        queryClient.invalidateQueries({ queryKey: roadworksQueryKeys.layer() })
    }, [config, onSuccess, queryClient, selectedNetwork])

    return useRoadworksMutation(
        url,
        axiosInstance.delete,
        {
            ...queryParameters,
        },
        {
            ...config,
            enabled: roadworkProject && roadwork?.uuid && enabled,
            onSuccess: onDeleteSuccess,
        },
    )
}